import $ from 'jquery';

export const init = () => {

	$(document)
		.on('click', '.js-tabs__link', function(e) {
			e.preventDefault();

			var $this = $(this),
				$parent = $this.closest('.js-tabs'),
				$item = $this.closest('.js-tabs__item'),
				$items = $parent.find('.js-tabs__item'),
				$tabs = $parent.find('.js-tabs__fragment');

			$items.removeClass('is-active');
			$tabs.removeClass('is-active');

			$item.addClass('is-active');
			$tabs.filter( $this.attr('href') ).addClass('is-active');
		});
};
